import React from 'react';
import { Grid } from '@material-ui/core';
import Proptypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import DamageInfoIcon from '../../../../img/formSectionIcons/damageInfo.svg';

const AccidentDetails = ({
  formProps: { errors, clearError },
  accidentDetails,
  handleAccidentDetailsChange,
  handleAccidentPreventionChange,
  accidentPrevention,
}) => (
  <FormSection title="propertyClaim.accInfo.accidentDetails" icon={DamageInfoIcon}>
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <TextInputFieldWithValidation
          labelKey="propertyClaim.accInfo.accidentDetails"
          name="accidentDetails"
          value={accidentDetails}
          handleChange={(e) => {
            handleAccidentDetailsChange(e.target.value);
          }}
          multiline
          rows={4}
          formProps={
              {
                errors,
                clearError,
              }
            }
        />
      </Grid>
      <Grid item xs={12}>
        <TextInputFieldWithValidation
          labelKey="propertyClaim.accInfo.accidentPrevention"
          name="accidentPrevention"
          value={accidentPrevention}
          handleChange={(e) => {
            handleAccidentPreventionChange(e.target.value);
          }}
          multiline
          rows={4}
          formProps={
              {
                errors,
                clearError,
              }
            }
        />
      </Grid>
    </Grid>
  </FormSection>
);

AccidentDetails.propTypes = {
  formProps: Proptypes.shape({
    errors: Proptypes.shape({}),
    clearError: Proptypes.func,
  }).isRequired,
  accidentDetails: Proptypes.string,
  accidentPrevention: Proptypes.string,
  handleAccidentDetailsChange: Proptypes.func,
  handleAccidentPreventionChange: Proptypes.func,
};

AccidentDetails.defaultProps = {
  accidentDetails: '',
  accidentPrevention: '',
  handleAccidentDetailsChange: () => { },
  handleAccidentPreventionChange: () => { },
};

export default AccidentDetails;
